// `src/util/market/AllItemsData.js`
import ItemData from './ItemData';

class AllItemsData {
    constructor(data) {
        this.itemsMap = new Map();
        data.forEach(item => {
            this.itemsMap.set(item.itemType, new ItemData(item));
        });
    }

    getItemData(itemType) {
        return this.itemsMap.get(itemType);
    }

    getAllItems() {
        return Array.from(this.itemsMap.values());
    }
}

export default AllItemsData;